module.exports = __webpack_public_path__ + "mo.svg?a60c624ee0c8221860149536a7a25beb";